<template>
    <v-layout row wrap justify-center>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <!-- Header -->
        <v-flex xs12 sm12 md12 lg12 xl12>
        </v-flex>
        
        <!-- Content -->
        <v-flex xs12 sm12 md7 lg7 xl7>
            <v-card
                shaped
                elevation=3
                class="pa-2"
                >
                <v-card-title class="d-flex d-sm-none subtitle-1 font-weight-bold">Consultoria Completa User Function</v-card-title>
                <v-card-title class="d-none d-sm-flex title">Consultoria Completa User Function</v-card-title>
                <v-divider class="mx-4 mb-4"></v-divider>
                <v-card-text v-show="!answered">
                    <v-form
                        ref="form"
                        v-model="valid"
                        lazy-validation>

                        <v-text-field
                        v-model="name"
                        label="Nome"
                        :rules="nameRules"
                        dense
                        required
                        ></v-text-field>

                        <v-text-field
                        v-model="mail"
                        label="E-mail"
                        :rules="mailRules"
                        dense
                        required
                        ></v-text-field>
                        
                        <v-text-field
                        v-model="company"
                        label="Empresa"
                        :rules="companyRules"
                        dense
                        required
                        ></v-text-field>
                        
                        <v-text-field
                        v-model="phone"
                        label="Telefone"
                        :rules="phoneRules"
                        dense
                        required
                        ></v-text-field>

                        <!-- <v-text-field
                        v-model="course"
                        label="Curso"
                        dense
                        disabled
                        required
                        ></v-text-field> -->
                        
                        <v-card-text class="pa-0 ma-0 my-2 font-weight-bold">
                            Conte-nos um pouco sobre a necessidade da sua empresa:
                        </v-card-text>
                        <v-textarea
                        v-model="message"
                        :rules="messageRules"
                        dense
                        outlined
                        rounded
                        
                        required
                        ></v-textarea>  

                        <v-btn
                            :disabled="!valid"
                            color="success"
                            class="mr-4"
                            @click="validate"
                        >
                        Enviar
                        </v-btn>              

                    </v-form>
                </v-card-text>
                <v-card-text v-show="answered" class="title text-center font-weight-black grey--text text--darken-3">
                    Agradecemos o seu contato. Responderemos sua solicitação o mais breve possível. :)
                </v-card-text>
            </v-card>
        </v-flex>
        
        <!-- Footer -->
        <v-flex xs12 sm12 md12 lg12 xl12>
        </v-flex>        
    </v-layout>
</template>

<script>
import { baseApiUrl, cloneDeep, showSuccess, showError } from '@/global'
import axios from 'axios'

export default {
    name: 'formTReports',
    components: {  },
    data: function() {
        return {
            overlay: false,
            answered: false,
            valid: true,
            name: '',
            nameRules: [
                v => !!v || 'Nome é necessário',
            ],
            mail: '',
            mailRules: [
                v => !!v || 'E-mail é necessário',
                v => /.+@.+\..+/.test(v) || 'E-mail inválido',
            ],
            company: '',
            companyRules: [
                v => !!v || 'Empresa é necessária',
            ],
            phone: '',
            phoneRules: [
                v => !!v || 'Telefone é necessário',
            ],
            course: '',
            message: '',
            messageRules: [
                v => !!v || 'Uma descrição é necessária',
            ],
        }
    },
    methods: {
        validate () {
            this.overlay = true
            if (this.$refs.form.validate()) {
                this.snackbar = true
                
                const url = `${baseApiUrl}/consult`
                const payload = {
                    name: this.name,
                    mail: this.mail,
                    company: this.company,
                    phone: this.phone,
                    course: this.course,
                    message: this.message,
                }
                axios.post(url, payload)
                    .then(async res => {
                        if (res.status === 200) {
                            this.$refs.form.reset()
                            this.answered = true
                            this.overlay = false
                        }
                    })
                    .catch((error) => {
                        this.overlay = false
                        showError(error)
                    })
            } else {
                this.overlay = false
                showError('Existem erros no formulário, favor conferir!')
            }
        },
    },
    created() {
        this.course = this.$route.query.course
    }
}
</script>

<style>
</style>
